var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hdr-navigation"},[_vm._v("hhh "),_vm._l((this.$store.state.navigation),function(item){return _c('div',{key:item.name,class:_vm.classObject(item.name, item.enabled),on:{"click":function($event){return _vm.selectNavigation(item.name, item.path, item.enabled)}}},[_vm._v(_vm._s(item.title))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }